import { Settings } from "../config";
import { LanderConfig } from "../types/LanderConfig";

/** The `keywords.source` the API sets when the terms came from the LLM. */
export const LLM_KEYWORDS_SOURCE = "llm";

/**
 * The LLM keyword terms ParkWeb API sent for this domain (PARKING-5307), best
 * first, or `[]`.
 *
 * Empty unless the LLM_KEYWORDS_ENABLED switch is on, `keywords.source` is
 * "llm" and there is at least one term. Every consumer (Yahoo Partner Supplied
 * Terms, the RollerAds 1-click list, the `llmKeywordsUsed` event field) asks
 * here, so the switch and the source check live in one place.
 */
export function llmKeywordTerms(
  landerConfig?: Pick<LanderConfig, "keywords"> | null
): string[] {
  if (!Settings.LLM_KEYWORDS_ENABLED) return [];

  const keywords = landerConfig?.keywords;
  if (keywords?.source !== LLM_KEYWORDS_SOURCE) return [];

  return keywords.terms?.length ? keywords.terms : [];
}

/**
 * Title-cases an LLM term for display (PARKING-5307).
 *
 * `toTitleCase` only knows ASCII word characters, so "água de coco" would render
 * "áGua De Coco". This capitalises the first letter of each whitespace-separated
 * word with the casing rules of the keywords' language (so Turkish gets "İ") and
 * leaves the rest of the word alone. Scripts without case (ja, th, zh) come back
 * unchanged. An unusable language tag falls back to default casing.
 *
 * Only for terms that came from llmKeywordTerms; other rows keep `toTitleCase`
 * so the switch-off output stays identical.
 */
export function llmTermTitleCase(term: string, language?: string): string {
  return term.replace(/\S+/g, (word) => {
    // A first letter outside the BMP is a surrogate pair.
    const firstLength = /[\uD800-\uDBFF]/.test(word.charAt(0)) ? 2 : 1;
    const first = word.slice(0, firstLength);
    let upper: string;
    try {
      upper = first.toLocaleUpperCase(language);
    } catch (e) {
      upper = first.toLocaleUpperCase();
    }
    return upper + word.slice(firstLength);
  });
}
